export const isSearchAnUrl = (search: string | undefined) => {
    return Boolean(search?.match(/^https?:\/\//));
  };